(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["events-hero"]) return;
  try {
    
if ( jQuery('.orbit').length != 0 ) {
  new Foundation.Orbit(jQuery('#HeroOrbit'), {
    autoPlay: false
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

var hamburger_target = $('.site-nav');
$('.hamburger a').on('click', function (evt) {
  evt.preventDefault();
  hamburger_target.toggle();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"]) return;
  try {
    
if ( jQuery('.orbit').length != 0 ) {
  new Foundation.Orbit(jQuery('#HeroOrbit'), {
    autoPlay: false
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-corby"]) return;
  try {
    
if ( jQuery('.orbit').length != 0 ) {
  new Foundation.Orbit(jQuery('#MobileOrbit'), {
    autoPlay: false
  });
  new Foundation.Orbit(jQuery('#LargeOrbit'), {
    autoPlay: false
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-merchandise"]) return;
  try {
    
if ( jQuery('.orbit').length != 0 ) {
  new Foundation.Orbit(jQuery('#ProductOrbit'), {
    autoPlay: false
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-upcoming-event"]) return;
  try {
    
if ( jQuery('.orbit').length != 0 ) {
  new Foundation.Orbit(jQuery('#ProductOrbit'), {
    autoPlay: false
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-whisky-family"]) return;
  try {
    
  if ( jQuery('.orbit').length != 0 ) {
    new Foundation.Orbit(jQuery('#MobileOrbit'), {
      autoPlay: false
    });
    new Foundation.Orbit(jQuery('#LargeOrbit'), {
      autoPlay: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
if (!!window.MSInputMethodContext && !!document.documentMode) {
  // IE 11 Only
  $('.maintenance-message').show();
}
else
{
  $('.product-form').show();
}

  } catch(e) { console.error(e); }
})();
})();
